// src/Redirection.js
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Redirection() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirection immédiate
    navigate("/devenez-jure/lyon-10/12/25", { replace: true });
  }, [navigate]);

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <p>Redirection en cours…</p>
    </div>
  );
}
